<div class="container">
  <app-logo class="container__logo"
    (click)="routing.goToIndex()"
  ></app-logo>
</div>
